import createIsValid from '../selectors/isValid';
import immutable from '../structure/immutable';

export default createIsValid(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/isValid.js
// module id = 1209
// module chunks = 0